import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { ContactHistoryItem } from '../../models/Contact';

export interface CompanyContactHistoryResponse {
  history: ContactHistoryItem[];
}

interface GetCompanyContactHistoryPayload {
  company_id: string;
  contact_id: string;
}

export async function getCompanyContactHistory(
  payload: GetCompanyContactHistoryPayload,
  auth: Authentication,
): Promise<CompanyContactHistoryResponse> {
  try {
    if (!payload.company_id || !payload.contact_id) {
      throw new GetCompanyContactHistoryFailure('company_id et contact_id sont requis');
    }

    const response = await HttpClient.post('/company/contacts/history', payload, auth.token);

    return response.data as CompanyContactHistoryResponse;
  } catch (e) {
    console.error('getCompanyContactHistory error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetCompanyContactHistoryFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetCompanyContactHistoryFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetCompanyContactHistoryFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
